// src/pages/equipmentrentaladmin/notification/NotificationsPage.jsx

import React, { useState, useContext, useEffect } from 'react';
import { Container, Row, Col, Card, Badge, Button, ButtonGroup } from 'react-bootstrap';
import {
  FaBell, FaClock, FaTrash, FaEnvelopeOpen, FaTractor, FaTools,
  FaMoneyBillWave, FaExclamationTriangle, FaCheckCircle, FaUserPlus
} from 'react-icons/fa';
import axios from 'axios';
import AppContext from "../../../context/AppContext.js";
import '../../../assets/css/equipmentrentaladmin/notification/Notification.css';
import RentalAdminLayout from '../../../layout/equipmentrentaladmin/RentalAdminLayout';
import Swal from "sweetalert2";
import { getEcho } from "../../../utils/echo";

// ✅ FIX 1: type se icon decide karo — DB se icon nahi aata
const getTypeIcon = (type) => {
  const map = {
    rental:      FaTractor,
    payment:     FaMoneyBillWave,
    maintenance: FaTools,
    dispute:     FaExclamationTriangle,
  };
  return map[type] || FaBell;
};

// ✅ FIX 2: created_at ko readable format mein convert karo
const formatTime = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleString('en-PK', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
};

const NotificationsPage = () => {
  const { baseUrl, loggedInRental ,authToken} = useContext(AppContext);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);

  // ── PUSHER — is rental admin ke liye naya notification aate hi list
  //    ke upar add ho jayega, real-time ──
  useEffect(() => {
    if (!loggedInRental?.id) return;

    const echo = getEcho(baseUrl);
    if (!echo) return;

    const channel = echo.private(`rentaladmin.${loggedInRental.id}`);

    channel.listen(".new-notification", (e) => {
      setNotifications((prev) => [e.notification, ...prev]);
    });

    return () => {
      echo.leave(`rentaladmin.${loggedInRental.id}`);
    };
  }, [loggedInRental, baseUrl]);

  // ✅ FIX 3: isRead check — DB se status string "unread" aata hai
  const isUnread = (n) => n.status === 'unread' || n.isRead === false;

  const unreadCount = notifications.filter(isUnread).length;

  // ✅ FIX 4: filter bhi status se karo
  const filteredNotifications = notifications.filter(notif => {
    if (filter === 'unread') return isUnread(notif);
    if (filter === 'read')   return !isUnread(notif);
    return true;
  });

  // ── API ── 
  const viewAllNotifications = () => {
    const formData = new FormData();
    formData.append("srrentaladmin_id", loggedInRental.id);
    setLoading(true);
    axios
      .post(
        `${baseUrl}/rentaladmin/notifications/viewAllNotifications`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" ,
          Authorization: `Bearer ${authToken}`
        } } // ✅ FIX 5: Headers→headers, formData spelling
      )
      .then((response) => {
        console.log(response.data);
        setLoading(false);
        if (response.data.hasOwnProperty("error")) {
          Swal.fire({ icon: "error", title: "Error", text: response.data.error });
        } else {
          setNotifications(response.data.notifications);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        Swal.fire({ icon: "error", title: "Error", text: "Failed to load notifications." });
      });
  };

  useEffect(() => {
    viewAllNotifications();
  }, []);

  // ── Handlers — ab sab backend ko call karte hain ──
  const markAsRead = (id) => {
    axios
      .post(
        `${baseUrl}/rentaladmin/notifications/markAsRead`,
        { id, srrentaladmin_id: loggedInRental.id },
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then((res) => {
        if (res.data.success) {
          setNotifications((prev) =>
            prev.map((n) => (n.id === id ? { ...n, isRead: true, status: 'read' } : n))
          );
        }
      })
      .catch(() => {
        Swal.fire({ icon: "error", title: "Error", text: "Failed to mark notification as read." });
      });
  };

  const markAllAsRead = () => {
    axios
      .post(
        `${baseUrl}/rentaladmin/notifications/markAllAsRead`,
        { srrentaladmin_id: loggedInRental.id },
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then((res) => {
        if (res.data.success) {
          setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true, status: 'read' })));
        }
      })
      .catch((err) => console.log(err));
  };

  const deleteNotification = (id) => {
    if (!window.confirm('Delete this notification?')) return;
    axios
      .post(
        `${baseUrl}/rentaladmin/notifications/deleteNotification`,
        { id, srrentaladmin_id: loggedInRental.id },
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then((res) => {
        if (res.data.success) {
          setNotifications((prev) => prev.filter((n) => n.id !== id));
        }
      })
      .catch((err) => console.log(err));
  };

  const clearAllRead = () => {
    if (!window.confirm('Clear all read notifications?')) return;
    axios
      .post(
        `${baseUrl}/rentaladmin/notifications/clearRead`,
        { srrentaladmin_id: loggedInRental.id },
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then((res) => {
        if (res.data.success) {
          setNotifications((prev) => prev.filter((n) => isUnread(n)));
        }
      })
      .catch((err) => console.log(err));
  };

  // ── Type badge ──
  const getTypeBadge = (type) => {
    const map = {
      rental:      { label: 'Rental',      bg: '#FFF8E6', color: '#FDB714' },
      payment:     { label: 'Payment',     bg: '#E6F9EE', color: '#28a745' },
      maintenance: { label: 'Maintenance', bg: '#FFF3E6', color: '#fd7e14' },
      dispute:     { label: 'Dispute',     bg: '#FFE6E6', color: '#dc3545' },
    };
    return map[type] || { label: type, bg: '#f0f0f0', color: '#666' };
  };

  // ================================================================
  // RETURN
  // ================================================================
  return (
    <RentalAdminLayout>
      <div className="notifications-page">
        <Container fluid>

          {/* ── Header ── */}
          <div className="notifications-header">
            <div className="header-left">
              <h2 className="page-title">Notifications</h2>
              {unreadCount > 0 && (
                <Badge className="unread-badge">{unreadCount} Unread</Badge>
              )}
            </div>
            <div className="header-actions">
              <Button
                className="mark-all-btn"
                onClick={markAllAsRead}
                disabled={unreadCount === 0}
              >
                <FaEnvelopeOpen /> Mark All as Read
              </Button>
              <Button
                variant="outline"
                className="clear-all-btn"
                onClick={clearAllRead}
              >
                Clear Read
              </Button>
            </div>
          </div>

          {/* ── Filter Tabs ── */}
          <div className="filter-section">
            <ButtonGroup className="filter-buttons">
              <Button
                className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
                onClick={() => setFilter('all')}
              >
                All ({notifications.length})
              </Button>
              <Button
                className={`filter-btn ${filter === 'unread' ? 'active' : ''}`}
                onClick={() => setFilter('unread')}
              >
                Unread ({unreadCount})
              </Button>
              <Button
                className={`filter-btn ${filter === 'read' ? 'active' : ''}`}
                onClick={() => setFilter('read')}
              >
                Read ({notifications.length - unreadCount})
              </Button>
            </ButtonGroup>
          </div>

          {/* ── Loading ── */}
          {loading && (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <p>Loading notifications...</p>
            </div>
          )}

          {/* ── Notifications List ── */}
          {!loading && (
            <Row>
              <Col>
                <div className="notifications-list">
                  {filteredNotifications.length > 0 ? (
                    filteredNotifications.map(notification => {
                      // ✅ FIX 1: icon type se
                      const IconComponent = getTypeIcon(notification.type);
                      const typeBadge = getTypeBadge(notification.type);
                      const unread = isUnread(notification);

                      return (
                        <Card
                          key={notification.id}
                          className={`notification-card ${unread ? 'unread' : ''}`}
                        >
                          <Card.Body>
                            <div className="notification-content">

                              {/* Icon */}
                              <div
                                className="notification-icon"
                                style={{
                                  backgroundColor: `${typeBadge.color}20`,
                                  color: typeBadge.color
                                }}
                              >
                                <IconComponent size={20} />
                              </div>

                              {/* Details */}
                              <div className="notification-details">
                                <div className="notification-title-row">
                                  <h5 className="notification-title">{notification.title}</h5>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span style={{
                                      fontSize: '11px', fontWeight: 600,
                                      padding: '2px 8px', borderRadius: '20px',
                                      background: typeBadge.bg, color: typeBadge.color
                                    }}>
                                      {typeBadge.label}
                                    </span>
                                    {unread && (
                                      <Badge className="new-badge">New</Badge>
                                    )}
                                  </div>
                                </div> 

                                {/* ✅ FIX 7: DB mein description hai, message nahi */}
                                <p className="notification-message">
                                  {notification.description || notification.message}
                                </p>

                                {/* ✅ FIX 2: created_at format karo */}
                                <span className="notification-time">
                                  <FaClock size={11} style={{ marginRight: 4 }} />
                                  {formatTime(notification.created_at || notification.time)}
                                </span>
                              </div>

                              {/* Actions */}
                              <div className="notification-actions">
                                {unread && (
                                  <button
                                    className="action-btn read-btn"
                                    onClick={() => markAsRead(notification.id)}
                                    title="Mark as read"
                                  >
                                    <FaEnvelopeOpen />
                                  </button>
                                )}
                                <button
                                  className="action-btn delete-btn"
                                  onClick={() => deleteNotification(notification.id)}
                                  title="Delete"
                                >
                                  <FaTrash />
                                </button>
                              </div>

                            </div>
                          </Card.Body>
                        </Card>
                      );
                    })
                  ) : (
                    <div className="no-notifications">
                      <FaBell className="no-notif-icon" />
                      <h4>No Notifications</h4>
                      <p>You're all caught up! No {filter === 'all' ? '' : filter} notifications to show.</p>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          )}

        </Container>
      </div>
    </RentalAdminLayout>
  );
};

export default NotificationsPage;